import React, { useEffect, useState } from 'react';
import { IMG_BASE_URL } from '../../Helpers';
import { getDiscountedPrice } from '../../Utils';
import { useParams } from "react-router-dom";
import { useApp } from '../../AppContext';
import AuthorDetails from '../authors/AuthorDetails';
import { useNavigate } from "react-router-dom";
import { fetchBookById } from '../../apiCalls';
export default function ViewBook() {
    const { id } = useParams();
    const { books, oldBooks } = useApp();

    const [book, setBook] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const allBooks = [...books, ...oldBooks];
        console.log("allBooks", allBooks)
        const foundBook = allBooks.find(
            (item) => item.book_id.toString() === id
        );

        if (foundBook) {
            setBook(foundBook);
            setLoading(false);
        } else {
            fetchBookById();
        }

    }, [id, books, oldBooks]);

    const fetchBookById = async () => {
        try {
            const response = await fetchBookById(id);
            setBook(response);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="text-center mt-5">Loading...</div>;
    }

    if (!book) {
        return <div className="text-center mt-5">Book not found</div>;
    }
    const handleEdit = (row) => {
        navigate(`/update-book/${id}`);
    };
    return (
        <>
            <div className='page-title-container'>
                <h2>Book Details <span>Details of the book</span></h2>
                <button className="btn btn-secondary save-btn btn-sm" onClick={() => handleEdit()}>
                    <i
                        className="bi bi-pencil text-warning"
                        data-tooltip-id="editTooltip"
                        data-tooltip-content="Edit Book"
                    ></i> Edit</button>
            </div>

            <section className="py-5">
                <div className="container px-4 px-lg-5 my-5">
                    <div className="row gx-4 gx-lg-5 align-items-center">
                        <div className="col-md-6">
                            <img
                                className="card-img-top mb-5 mb-md-0"
                                src={IMG_BASE_URL + "books/" + book.image}
                                alt={book.book_name}
                            />
                        </div>

                        <div className="col-md-6 book-details-admin">
                            <h1 className="display-5 fw-bolder">
                                {book.book_name}
                            </h1>

                            <p><span>Category : </span>{book.category_name}</p>
                            <p><span>MRP:  </span>₹{book.mrp}</p>
                            <p><span>Discount:  </span> {book.discount_percent}%</p>
                            <p><span>Selling Price:  </span>₹{getDiscountedPrice(
                                book.mrp,
                                book.discount_percent
                            ).toFixed(2)}</p>
                            <p><span>Binding : </span>{book.binding}</p>
                            <p><span>No of Pages : </span>{book.no_of_pages}</p>
                            <p><span>Published Year : </span>{book.published_year}</p>

                            <p
                                className="lead"
                                dangerouslySetInnerHTML={{
                                    __html: book.description
                                }}
                            ></p>
                            <p><span>Amazon Link:  </span>{book.amazon_link}</p>
                            <p><span>Flipkart Link:  </span>{book.flipkart_link}</p>
                        </div>
                    </div>
                    <div className="row gx-4 gx-lg-5 align-items-center mt-5 ">
                        {book.authors && book.authors.length > 0 && <h3>Authors</h3>}
                        {
                            book?.authors?.map((item, index) => (
                                < AuthorDetails author={item} bookId={book.book_id} key={book.book_id} />
                            ))
                        }
                    </div>
                </div>
            </section>
        </>
    );
}